export default __webpack_public_path__ + "static/media/projects.97ecd0a4.jpg";